module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.composeClass(),
    attrs: {
      "id": _vm.domUid,
      "role": "flash-information"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7559e7b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flash/Reveal.vue
// module id = 482
// module chunks = 2